<script setup lang="ts">
const props = defineProps<{
  title: string,
  slug: string,
  avatarUrl: string,
  headerUrl: string,
  description: string
}>()

const computedUrl = computed(() => `/group/${props.slug}`)
</script>
<template>
  <v-card
    class="card-group card"
    style=" position: relative;border-color: #0000001f; border-radius: 8px;"
    elevation="0"
    variant="outlined"
    :to="computedUrl"
  >
    <v-card-text class="d-flex">
      <v-img
        :src="avatarUrl"
        class="card-group__avatar mr-4"
        width="80"
        max-width="80"
        height="80"
      />
      <div>
        <p class="text-body-2">
          {{ title }}
        </p>
        <p class="text-caption text-grey-darken-1">
          @{{ slug }}
        </p>
        <p class="text-caption text-grey-darken-1 mt-2">
          {{ description }}
        </p>
      </div>
    </v-card-text>
  </v-card>
</template>

<style scoped lang="scss">
.card-group {
  cursor: pointer;

  &__header-cover {
    aspect-ratio: 2 / 1;
    background-color: #fae99c;
  }

  &__title {
    display: flex;
    overflow: unset;
  }
}
</style>
